<template>
  <Modal
    :modalId="modalId"
    ref="circular-cancel-modal"
    modalType="small-modal"
    class="ecircular-modal"
    :showCloseBtn="false"
  >
    <p
      slot="modal-header"
      class="font-bold"
    >{{ $t('hint.cancelECircular') }}</p>
    <div slot="btns">
      <button
        class="btn--orange"
        @click="close()"
      >{{ $t('action.no') }}</button>
      <button
        class="btn--darkblue"
        @click="_cancelECircular()"
      >{{ $t('action.yes') }}</button>
    </div>
  </Modal>
</template>

<script>
import { mapActions } from 'vuex'
import Modal from '@/controls/Modal'

export default {
  name: 'cancelECircular',

  components: {
    Modal,
  },

  data () {
    const modalId = `cancelModal-${new Date().getTime()}-${Math.floor(Math.random() * 1000)}`
    return {
      modalId,
    }
  },

  methods: {
    ...mapActions('ecircular', [
      'cancelECircular',
    ]),

    async _cancelECircular () {
      await this.cancelECircular()
      this.close()
    },

    close () {
      this.$refs['circular-cancel-modal'].close()
    },

    open () {
      this.$refs['circular-cancel-modal'].open()
    },
  },
}
</script>
